import { getFiwareSourceIds } from './useFiwarePlots';
import { fiwareDataAtom, menuItemsAtom } from '../atoms';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { MEASURE_SOURCE_NAME } from '../constants/lib/measureDistanceControlUtils';
import { TERRAIN_DEM_ID } from '../constants/hooks/useTerrainControl';
import { useGetTileUrlsByType } from './useGetTileUrls';
import { ALERT_TILE_ID } from './getFeatures';

/**
 * 全データのsourceIdsを取得する
 * @returns sourceIds
 */
export const useGetSourceIds = () => {
  
  const fiwareData = useAtomValue(fiwareDataAtom);
  const menuItems = useAtomValue(menuItemsAtom);
  const dataPngUrls = useGetTileUrlsByType('datapng');
  const rasterUrls = useGetTileUrlsByType('raster');
  const vectorTileUrls = useGetTileUrlsByType('vector');

  // useMemo を使用して sourceIds の計算結果をメモ化する
  const sourceIds = useMemo(() => {

    /** 基本のソースID */
    const ids = [MEASURE_SOURCE_NAME, TERRAIN_DEM_ID, ALERT_TILE_ID];

    /** 個別のベクトルタイルのソースID */
    vectorTileUrls.forEach((item) => {
      ids.push(item.tileId);
    });

    /** メニューアイテムのソースID */
    menuItems?.forEach((item) => {
      ids.push(item.tileId);
    });

    /** FIWAREのソースID */
    const fiwareSourceIds = getFiwareSourceIds(fiwareData);
    ids.push(...fiwareSourceIds);

    /** データPNGのソースID  */
    dataPngUrls.forEach((item) => {
      ids.push(item.tileId);
    });

    /** ラスタータイルのソースID */
    rasterUrls.forEach((item) => {
      ids.push(item.tileId);
    });

    return ids;
  }, [dataPngUrls, fiwareData, rasterUrls, vectorTileUrls]);

  return sourceIds;
};

/**
 * FIWAREのデータからsourceIdsを取得する
 * @returns sourceIds
 */
export const useGetFiwareSourceIds = () => {

  const fiwareData = useAtomValue(fiwareDataAtom);

  // useMemo を使用して sourceIds の計算結果をメモ化する
  const sourceIds = useMemo(() => {
    const fiwareSourceIds = getFiwareSourceIds(fiwareData);

    return fiwareSourceIds;
  }, [fiwareData]);

  return sourceIds;
}
